import React, { createContext, useState } from 'react';

interface FilePreviewContextType {
    isFilePreviewModalOpen: boolean;
    setIsFilePreviewModalOpen: (value: boolean) => void;
    files: any[];
    setFiles: (files: any[]) => void;
}

export const FilePreviewContext = createContext<FilePreviewContextType>({
    isFilePreviewModalOpen: false,
    setIsFilePreviewModalOpen: () => {},
    files: [],
    setFiles: () => {},
});

export const FilePreviewProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [isFilePreviewModalOpen, setIsFilePreviewModalOpen] = useState(false);
    const [files, setFiles] = useState<any[]>([]);

    return (
        <FilePreviewContext.Provider
            value={{
                isFilePreviewModalOpen,
                setIsFilePreviewModalOpen,
                files,
                setFiles,
            }}
        >
            {children}
        </FilePreviewContext.Provider>
    );
};
